import { api, ApiResponse, authHeader } from '@you-go-vn/components';
import { GetOrderListParams, OrderDetail, OrderResource } from './type';

const defaultPathApi = '/api/orders';

type Data = {
  items: OrderResource[];
  total: number;
  totalPage: number;
};

const get = async (params: GetOrderListParams) => {
  return api.get<ApiResponse<Data>>(defaultPathApi, {
    headers: authHeader(),
    params: params,
  });
};

const getById = async (id: string) => {
  return api.get<ApiResponse<OrderDetail>>(`${defaultPathApi}/${id}`, {
    headers: authHeader(),
  });
};

export const ordersV2Service = {
  get,
  getById
};
